import { styled, css, Box, BoxProps } from '@mui/material'
import { getUnitValue } from '../../../utils/processStyles'
import { GridStylesProps } from './Grid.types'

export const GridWrapper = styled(Box)<GridStylesProps & BoxProps>(
  ({ columns, gap }) => css`
    display: grid;
    grid-template-columns: repeat(${columns}, minmax(0, 1fr));
    gap: ${getUnitValue(gap)};
  `
)
GridWrapper.defaultProps = {
  columns: 1,
  gap: 12
}

export default GridWrapper
